<template>
  <jtCard
    containerHeight="429"
    title="仓储货物到发情况"
    style="margin-bottom: 30px"
  >
    <div class="container">
      <div
        class="chart"
        id="StorageContainer"
        style="width: 100%; height: 350px"
      ></div>
      <!-- <div v-else>暂无数据</div> -->
    </div>
  </jtCard>
</template>
<script>
//先导入charts
import Charts from "@jiaminghi/charts";
import jtCard from "@/components/Card";
export default {
  components: {
    jtCard,
  },
  props: {
    tbWarehousingGoods: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {
    // let _this = this;
    // 在mouted里面做了一个立即执行函数 ，防止里面的变量污染
    (function () {
      //下面和eacharts差不多
      const container = document.getElementById("StorageContainer");
      const myChart = new Charts(container);
      const option = {
        // title: {
        //   text: '周销售额趋势'
        // },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          show:true,
          top: 40,
          left:180,
          selectAble:true,
          textStyle: {
            fill: "#5BB0FF",
            fontSize: 20,
          },
          textUnselectedStyle: {
            fontFamily: 'Arial',
            fontSize: 13,
            fill: '#2DF9CC'
          },
          data: [
            { name: "日进吨", color: "#5BB0FF"},
            { name: "日出吨", color: "#598CD7" },
            { name: "日结存吨", color: "#2CF0C7"},
          ],
        },

        xAxis: {
          name: '日期',
          data: ['6-4', '6-5', '6-6', '6-7', '6-8', '6-9', '6-10'],
          axisLabel: {
            style: {
              fontSize: 20,
              fill: "#fff",
            },
          },
          axisTick:{
            show: false
          }
        },
        yAxis: {
          name: '吨',
          data: 'value',
          axisLine: {
            style: {
              borderType: "dashed",
            },
            // show:false
          },
          splitLine:{
            show: false
          },
          axisLabel: {
            style: {
              fontSize: 20,
              fill: "#fff",
            },
          },

        },
        series: [
          {
            name: "日进吨",
            data: [120, 223, 190, 210, 350, 220, 308],
            type: 'line',
            smooth: true,
            lineArea: {
              show: true,
              gradient: ["RGBA(91, 176, 255, 1)", "RGBA(91, 176, 255, 0.08)"],
            },
            lineStyle: {
              stroke: "#5BB0FF",
              lineWidth: 4
            },
            linePoint: {
              // radius: 6,
              style: {
                fill: "#5BB0FF",
                stroke: "transparent",
              },
            },

          },
          {
            name: "日出吨",
            data: [280, 273, 320, 410, 320, 510, 420],
            type: 'line',
            smooth: true,
            lineArea: {
              show: true,
              gradient: ["RGBA(89, 140, 215, 1)", "RGBA(89, 140, 215, 0.08)"],
            },
            lineStyle: {
              stroke: "#598CD7",
              lineWidth: 4
            },
            linePoint: {
              radius: 1,
              style: {
                fill: "#598CD7",
                stroke: "transparent",
              },
            },

          },
          {
            name: "日结存吨",
            data: [390, 403, 400, 600, 390, 620, 308],
            type: 'line',
            smooth: true,
            lineArea: {
              show: true,
              gradient: ["RGBA(44, 240, 199, 1)", "RGBA(44, 240, 199, 0.08)"],
            },
            lineStyle: {
              stroke: "#2CF0C7",
              lineWidth: 4
            },
            linePoint: {
              // radius: 6,
              style: {
                fill: "#2CF0C7",
                stroke: "transparent",
              },
            },

          }
        ]
       
      };

      myChart.setOption(option);

      //图表自适应
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    })();
  },
  methods: {},
};
</script>
<style scoped>
.chart {
  height: 240px;
  margin-left: 15px;
}

h2 {
  height: 48px;
  color: white;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  line-height: 48px;
}
</style>
